<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="true"
        mode="vertical"
      >
        <el-menu-item-group :title="`${this.$t('sidebar.admin.title')}`">
          <app-link :to="'intro'">
            <el-menu-item index="1-1">
              <item :icon="'info'" :title="this.$t('sidebar.admin.dashboard')"/>
            </el-menu-item>
          </app-link>
          <app-link :to="'enter-score'" v-if="checkPermission([UserRole.Admin, UserRole.Manager, UserRole.Professor])">
            <el-menu-item index="1-2">
              <item :icon="'barcode'" :title="this.$t('sidebar.admin.enter_score')"/>
            </el-menu-item>
          </app-link>
          <app-link :to="'user'" v-if="checkPermission([UserRole.Admin])">
            <el-menu-item index="1-3">
              <item :icon="'user'" :title="this.$t('sidebar.admin.user')"/>
            </el-menu-item>
          </app-link>
          <app-link :to="'import'" v-if="checkPermission([UserRole.Admin, UserRole.Manager])">
            <el-menu-item index="1-4">
              <item :icon="'import'" :title="this.$t('sidebar.admin.import')"/>
            </el-menu-item>
          </app-link>
        </el-menu-item-group>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import Item from './Item'
import AppLink from './Link'
import variables from '@/styles/variables.scss'
import { UserRole } from '@/enum'
import checkPermission from '@/utils/permission'

export default {
  components: { Logo, Item, AppLink },
  data () {
    return {
      UserRole: UserRole
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'sidebar',
      profile: 'auth/profile'
    }),
    routes () {
      return this.$router.options.routes
    },
    activeMenu () {
      const route = this.$route
      const { meta, name } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return name
    },
    showLogo () {
      return this.$store.state.settings.sidebarLogo
    },
    variables () {
      return variables
    },
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  methods: {
    checkPermission,
    routerNameActive (...routerName) {
      return routerName.includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.router-link-active {
  .el-menu-item {
    background: #4861799c !important;
    span, svg {
      color: #00a3f6;
    }

  }
}
.el-menu-item {
  border-top-right-radius: 26px;
  border-bottom-right-radius: 26px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/Sidebar/index.vue